var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-progress',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"fixed-top",attrs:{"height":"4px","max":"100","value":_vm.percentage}})}
var staticRenderFns = []

export { render, staticRenderFns }